/*
 * @Author: Pedro Kostelec
 * @Date:   2019-11-16 14:14:46
 * @Last Modified by:   Pedro Kostelec
 * @Last Modified time: 2021-03-24 16:08:58
 */

import { parseJSON } from "@/lib/utils";

export function loadBoat(accessToken, userBoatId) {
  return new Promise((resolve, reject) => {
    const headers = {
      "Content-Type": "application/json",
      Authorization: "Bearer " + accessToken,
    };
    let url = process.env.VUE_APP_BASE_API_URL + "boats/" + userBoatId + "/";
    fetch(url, {
      headers: headers,
    })
      .then(function(response) {
        if (!response.ok) {
          throw response;
        }
        resolve(response.json());
      })
      .catch(function(error) {
        if (error.json) {
          error.json().then(function(error) {
            reject(error);
          });
        } else {
          reject(error);
        }
      });
  });
}

export function loadEntries(accessToken, userBoatId) {
  return new Promise(function(resolve, reject) {
    var headers = {
      "Content-Type": "application/json",
      Authorization: "Bearer " + accessToken,
    };
    let url =
      process.env.VUE_APP_BASE_API_URL +
      "boats/" +
      userBoatId +
      "/service-logs/";
    fetch(url, {
      headers: headers,
    })
      .then(function(response) {
        if (!response.ok) {
          throw response;
        }
        resolve(response.json());
      })
      .catch(function(error) {
        if (error.json) {
          error.json().then(function(error) {
            reject(error);
          });
        } else {
          reject(error);
        }
      });
  });
}

export function loadEntry(accessToken, userBoatId, logEntryId) {
  return new Promise(function(resolve, reject) {
    var headers = {
      "Content-Type": "application/json",
      Authorization: "Bearer " + accessToken,
    };
    let url =
      process.env.VUE_APP_BASE_API_URL +
      "boats/" +
      userBoatId +
      "/service-logs/" +
      logEntryId +
      "/";
    fetch(url, {
      headers: headers,
    })
      .then(function(response) {
        if (!response.ok) {
          throw response;
        }
        resolve(response.json());
      })
      .catch(function(error) {
        if (error.json) {
          error.json().then(function(error) {
            reject(error);
          });
        } else {
          reject(error);
        }
      });
  });
}

export function updateLogEntry(accessToken, userBoatId, entry) {
  return new Promise(function(resolve, reject) {
    var headers = {
      "Content-Type": "application/json",
      Authorization: "Bearer " + accessToken,
    };
    let url =
      process.env.VUE_APP_BASE_API_URL +
      "boats/" +
      userBoatId +
      "/service-logs/" +
      entry.uuid +
      "/";
    fetch(url, {
      method: "PATCH",
      headers: headers,
      body: JSON.stringify(entry),
    })
      .then(function(response) {
        if (!response.ok) {
          throw response;
        }
        resolve(response.json());
      })
      .catch(function(error) {
        if (error.json) {
          error.json().then(function(error) {
            reject(error);
          });
        } else {
          reject(error);
        }
      });
  });
}

export function createLogEntry(accessToken, userBoatId, entry) {
  return new Promise(function(resolve, reject) {
    var headers = {
      "Content-Type": "application/json",
      Authorization: "Bearer " + accessToken,
    };
    let url =
      process.env.VUE_APP_BASE_API_URL +
      "boats/" +
      userBoatId +
      "/service-logs/";
    fetch(url, {
      method: "POST",
      headers: headers,
      body: JSON.stringify(entry),
    })
      .then(function(response) {
        if (!response.ok) {
          throw response;
        }
        resolve(response.json());
      })
      .catch(function(error) {
        if (error.json) {
          error.json().then(function(error) {
            reject(error);
          });
        } else {
          reject(error);
        }
      });
  });
}

export function createLogNote(accessToken, userBoatId, logEntryId, note) {
  return new Promise(function(resolve, reject) {
    var headers = {
      "Content-Type": "application/json",
      Authorization: "Bearer " + accessToken,
    };
    let url =
      process.env.VUE_APP_BASE_API_URL +
      "boats/" +
      userBoatId +
      "/service-logs/" +
      logEntryId +
      "/notes/";
    fetch(url, {
      method: "POST",
      headers: headers,
      body: JSON.stringify(note),
    })
      .then(function(response) {
        if (!response.ok) {
          throw response;
        }
        resolve(response.json());
      })
      .catch(function(error) {
        if (error.json) {
          error.json().then(function(error) {
            reject(error);
          });
        } else {
          reject(error);
        }
      });
  });
}

export function createResolvingLogNote(
  accessToken,
  userBoatId,
  logEntryId,
  note
) {
  return new Promise(function(resolve, reject) {
    var headers = {
      "Content-Type": "application/json",
      Authorization: "Bearer " + accessToken,
    };
    let url =
      process.env.VUE_APP_BASE_API_URL +
      "boats/" +
      userBoatId +
      "/service-logs/" +
      logEntryId +
      "/post-resolving-note/";
    fetch(url, {
      method: "POST",
      headers: headers,
      body: JSON.stringify(note),
    })
      .then(function(response) {
        if (!response.ok) {
          throw response;
        }
        resolve(response.json());
      })
      .catch(function(error) {
        if (error.json) {
          error.json().then(function(error) {
            reject(error);
          });
        } else {
          reject(error);
        }
      });
  });
}

export function uploadNoteAttachment(
  accessToken,
  userBoatId,
  logEntryId,
  logNoteId,
  file
) {
  return new Promise(function(resolve, reject) {
    const headers = {
      Authorization: "Bearer " + accessToken,
    };
    let url =
      process.env.VUE_APP_BASE_API_URL +
      "boats/" +
      userBoatId +
      "/service-logs/" +
      logEntryId +
      "/notes/" +
      logNoteId +
      "/post-attachment/";
    const formData = new FormData();
    formData.append("file", file);
    formData.append("title", file.name);
    fetch(url, {
      method: "POST",
      headers: headers,
      body: formData,
    })
      .then(function(response) {
        if (!response.ok) {
          throw response;
        }
        resolve(response.json());
      })
      .catch(function(error) {
        if (error.json) {
          error.json().then(function(error) {
            reject(error);
          });
        } else {
          reject(error);
        }
      });
  });
}

export function uploadNoteAttachmentMulti(
  accessToken,
  userBoatId,
  logEntryId,
  logNoteId,
  attachments
) {
  /*
	This is meant to be used in conjuction with S3 direct upload.

	attachments =
	[{
        "link": "somedirectlink",
        "title": "igla zamenjana",
    },
    {
        "link": "somedirectlink",
        "title": "igla zamenjana 2",
    }]
  
	*/

  return new Promise(function(resolve, reject) {
    var headers = {
      "Content-Type": "application/json",
      Authorization: "Bearer " + accessToken,
    };
    let url =
      process.env.VUE_APP_BASE_API_URL +
      "boats/" +
      userBoatId +
      "/service-logs/" +
      logEntryId +
      "/notes/" +
      logNoteId +
      "/post-attachment/";

    fetch(url, {
      method: "POST",
      headers: headers,
      body: JSON.stringify({
        has_multiple_attachments: true,
        attachments: attachments,
      }),
    })
      .then(function(response) {
        if (!response.ok) {
          throw response;
        }
        resolve(response.json());
      })
      .catch(function(error) {
        if (error.json) {
          error.json().then(function(error) {
            reject(error);
          });
        } else {
          reject(error);
        }
      });
  });
}

export function uploadResolvingNoteAttachment(
  accessToken,
  userBoatId,
  logEntryId,
  file
) {
  return new Promise(function(resolve, reject) {
    const headers = {
      Authorization: "Bearer " + accessToken,
    };
    let url =
      process.env.VUE_APP_BASE_API_URL +
      "boats/" +
      userBoatId +
      "/service-logs/" +
      logEntryId +
      "/post-resolving-attachment/";
    const formData = new FormData();
    formData.append("file", file);
    formData.append("title", file.name);
    fetch(url, {
      method: "POST",
      headers: headers,
      body: formData,
    })
      .then(function(response) {
        if (!response.ok) {
          throw response;
        }
        resolve(response.json());
      })
      .catch(function(error) {
        if (error.json) {
          error.json().then(function(error) {
            reject(error);
          });
        } else {
          reject(error);
        }
      });
  });
}

export function generalAssistanceRequest(accessToken, userBoatId, message) {
  return new Promise(function(resolve, reject) {
    var headers = {
      "Content-Type": "application/json",
      Authorization: "Bearer " + accessToken,
    };

    let url =
      process.env.VUE_APP_BASE_API_URL + "boats/" + userBoatId + "/problem/";

    fetch(url, {
      method: "POST",
      headers: headers,
      body: JSON.stringify({
        message: message,
        target: "PARTNER",
        message_type: "SERVICE_REQUEST",
      }),
    })
      .then(parseJSON)
      .then((response) => {
        if (response.ok && response.json) {
          return resolve(response.json);
        } else if (!response.ok && response.json) {
          // extract the error from the server's json
          return reject(response.json.detail);
        } else if (response.ok && response.text === "") {
          return resolve();
        } else {
          let message = "Something went wrong while loading json";
          console.error(response.text);
          return reject(message);
        }
      })
      .catch((error) => reject(error.message));
  });
}

export function entryAssistanceRequest(accessToken, userBoatId, logEntryId) {
  return new Promise(function(resolve, reject) {
    var headers = {
      "Content-Type": "application/json",
      Authorization: "Bearer " + accessToken,
    };
    let url =
      process.env.VUE_APP_BASE_API_URL +
      "boats/" +
      userBoatId +
      "/service-logs/" +
      logEntryId +
      "/request-assistance/";

    fetch(url, {
      method: "POST",
      headers: headers,
    })
      .then(parseJSON)
      .then((response) => {
        if (response.ok && response.json) {
          return resolve(response.json);
        } else if (!response.ok && response.json) {
          // extract the error from the server's json
          return reject(response.json.detail);
        } else if (response.ok && response.text === "") {
          return resolve();
        } else {
          let message = "Something went wrong while loading json";
          console.error(response.text);
          return reject(message);
        }
      })
      .catch((error) => reject(error.message));
  });
}

export function updateEntryStatus(
  accessToken,
  userBoatId,
  logEntryId,
  updateObject
) {
  return new Promise(function(resolve, reject) {
    var headers = {
      "Content-Type": "application/json",
      Authorization: "Bearer " + accessToken,
    };
    let url =
      process.env.VUE_APP_BASE_API_URL +
      "boats/" +
      userBoatId +
      "/service-logs/" +
      logEntryId +
      "/";

    fetch(url, {
      method: "PATCH",
      headers: headers,
      body: JSON.stringify(updateObject),
    })
      .then(parseJSON)
      .then((response) => {
        if (response.ok && response.json) {
          return resolve(response.json);
        } else if (!response.ok && response.json) {
          // extract the error from the server's json
          return reject(response.json.detail);
        } else {
          let message = "Something went wrong while loading json";
          console.error(response.text);
          return reject(message);
        }
      })
      .catch((error) => reject(error.message));
  });
}

export function fetchUpcomingServiceEvents(
  accessToken,
  userBoatId,
  logEntryId,
  updateObject
) {
  return new Promise(function(resolve, reject) {
    var headers = {
      "Content-Type": "application/json",
      Authorization: "Bearer " + accessToken,
    };

    let url =
      process.env.VUE_APP_BASE_API_URL +
      `boats/${userBoatId}/upcoming-services/`;

    fetch(url, {
      method: "GET",
      headers: headers,
      body: JSON.stringify(updateObject),
    })
      .then(parseJSON)
      .then((response) => {
        if (response.ok && response.json) {
          return resolve(response.json);
        } else if (!response.ok && response.json) {
          // extract the error from the server's json
          return reject(response.json.detail);
        } else {
          let message = "Something went wrong while loading json";
          console.error(response.text);
          return reject(message);
        }
      })
      .catch((error) => reject(error.message));
  });
}

export function createLogEntryFromServiceItems(accessToken, userBoatId, data) {
  return new Promise(function(resolve, reject) {
    var headers = {
      "Content-Type": "application/json",
      Authorization: "Bearer " + accessToken,
    };
    let url =
      process.env.VUE_APP_BASE_API_URL +
      "boats/" +
      userBoatId +
      "/upcoming-services/complete/";
    fetch(url, {
      method: "POST",
      headers: headers,
      body: JSON.stringify(data),
    })
      .then(function(response) {
        if (!response.ok) {
          throw response;
        }
        resolve(response.json());
      })
      .catch(function(error) {
        if (error.json) {
          error.json().then(function(error) {
            reject(error);
          });
        } else {
          reject(error);
        }
      });
  });
}

export function fetchResponsiveDealer(
  accessToken,
  userBoatId,
  logEntryId,
  updateObject
) {
  return new Promise(function(resolve, reject) {
    var headers = {
      "Content-Type": "application/json",
      Authorization: "Bearer " + accessToken,
    };

    let url = process.env.VUE_APP_BASE_API_URL + `boats/${userBoatId}/`;

    fetch(url, {
      method: "GET",
      headers: headers,
    })
      .then(parseJSON)
      .then((response) => {
        if (response.ok && response.json) {
          return resolve(response.json);
        } else if (!response.ok && response.json) {
          // extract the error from the server's json
          return reject(response.json.detail);
        } else {
          let message = "Something went wrong while loading json";
          console.error(response.text);
          return reject(message);
        }
      })
      .catch((error) => reject(error.message));
  });
}

function fetchS3UploadLink(accessToken, data) {
  /* 
	data should include key value pairs like user_boat_id or crm_uuid or partner_uuid which need to be posted. While optional, provide them if you can.
	Mandatory keys: 
		- file_type (file extension without dot)
		- assert_type (image_asset or document_asset)
	*/

  return new Promise(function(resolve, reject) {
    var headers = {
      "Content-Type": "application/json",
      Authorization: "Bearer " + accessToken,
    };
    let url = process.env.VUE_APP_BASE_API_URL + "direct-file-upload/";
    fetch(url, {
      method: "POST",
      headers: headers,
      body: JSON.stringify(data),
    })
      .then(function(response) {
        if (!response.ok) {
          throw response;
        }
        resolve(response.json());
      })
      .catch(function(error) {
        if (error.json) {
          error.json().then(function(error) {
            reject(error);
          });
        } else {
          reject(error);
        }
      });
  });
}

function s3FileUpload(url, formData) {
  return new Promise(function(resolve, reject) {
    fetch(url, {
      method: "POST",
      body: formData,
    })
      .then(function(response) {
        if (!response.ok) {
          throw response;
        }
        if (response.status === 204) {
          resolve();
        } else {
          resolve(response.json());
        }
      })
      .catch(function(error) {
        if (error.json) {
          error.json().then(function(error) {
            reject(error);
          });
        } else {
          reject(error);
        }
      });
  });
}

function uploadFilesViaS3(accessToken, filesToUpload) {
  /* 
	filesToUpload is a array of objects { file, meta }. 
	meta = {file_type, file_name, asset_type, [user_boat_id, partner_uuid, group_uuid]};

	meta should include key value pairs like user_boat_id or crm_uuid or partner_uuid which need to be posted. While optional, provide them if you can
	*/

  let uploadPromises = filesToUpload.map((fileObj) => {
    return fetchS3UploadLink(accessToken, fileObj.meta).then((WDresp) => {
      let fileData = new FormData();
      Object.keys(WDresp.fields).forEach((key) => {
        fileData.append(key, WDresp.fields[key]);
      });
      fileData.append("file", fileObj.file);

      return s3FileUpload(WDresp.url, fileData).then((s3resp) => {
        return Object.assign({}, fileObj, {
          file_url: WDresp.file_url,
          file_resource_uuid: WDresp.file_resource_uuid,
        });
      });
    });
  });

  return Promise.all(uploadPromises);
}

export function uploadFileResources(accessToken, filesToUpload, userBoatId) {
  /*
	userBoatId is optional, but recommended
	*/

  if (filesToUpload.length === 0) {
    return Promise.resolve([]);
  }

  let fileObjs = filesToUpload.map((file) => {
    let lastIndexOfChar = file.name.lastIndexOf(".");
    let fileName = file.name.substring(0, lastIndexOfChar);
    let fileType = file.name.substring(lastIndexOfChar + 1, file.name.length);

    let assetType = "document_asset";

    // if (["png", "jpg", "jpeg"].indexOf(fileType) > -1) {
    // 	assetType = "image_asset";
    // }
    let meta = {
      file_type: fileType,
      file_name: fileName,
      asset_type: assetType,
      user_boat_id: userBoatId,
      is_content_type_forced: true,
    };

    return {
      file: file,
      meta: meta,
    };
  });

  return uploadFilesViaS3(accessToken, fileObjs);
}

// export function uploadEntryAttachments(
// 	accessToken,
// 	userBoatId,
// 	logEntryId,
// 	logNoteId,
// 	filesToUpload
// ) {
// 	let fileObjs = filesToUpload.map((file) => {
// 		let lastIndexOfChar = file.name.lastIndexOf(".");
// 		let fileName = file.name.substring(0, lastIndexOfChar);
// 		let fileType = file.name.substring(
// 			lastIndexOfChar + 1,
// 			file.name.length
// 		);

// 		let assetType = "document_asset";

// 		// if (["png", "jpg", "jpeg"].indexOf(fileType) > -1) {
// 		// 	assetType = "image_asset";
// 		// }
// 		let meta = {
// 			file_type: fileType,
// 			file_name: fileName,
// 			asset_type: assetType,
// 			user_boat_id: userBoatId,
// 		};

// 		return {
// 			file: file,
// 			meta: meta,
// 		};
// 	});

// 	if (filesToUpload.length === 0) {
// 		return Promise.resolve([])
// 	}

// 	return uploadFilesViaS3(accessToken, fileObjs)
// 		.then((status) => {
// 			return status.map((asset) => {
// 				return { title: asset.file.name, link: asset.file_url };
// 			});
// 		})
// 		.then((attachments) => {
// 			return uploadNoteAttachmentMulti(
// 				accessToken,
// 				userBoatId,
// 				logEntryId,
// 				logNoteId,
// 				attachments
// 			);
// 		});
// }

export default {
  loadEntry,
  loadEntries,
  updateLogEntry,
  createLogEntry,
  createLogNote,
  uploadNoteAttachment,
  updateEntryStatus,
  createResolvingLogNote,
  fetchUpcomingServiceEvents,
  createLogEntryFromServiceItems,
  fetchResponsiveDealer,
  uploadNoteAttachmentMulti,
  generalAssistanceRequest,
  uploadFileResources,
};
